import { createAsyncThunk } from '@reduxjs/toolkit'
import okHttp from '@helper/okHttp'
import { user, getTypePrefix, sys } from '@/api'

/**
 * 客户列表
 * @type {AsyncThunk<Promise<*>, void, AsyncThunkConfig>}
 */
export const getUserListAction = createAsyncThunk(
    getTypePrefix(user.getUserList),
    async (params) => await okHttp(user.getUserList, {
        method: 'POST',
	    ...params
    })
)

/**
 * 注册应用列表
 * @type {AsyncThunk<Promise<*>, void, AsyncThunkConfig>}
 */
export const getTerminalAction = createAsyncThunk(
    getTypePrefix(user.getTerminal),
    async (params) => await okHttp(user.getTerminal, {
        method: 'GET',
	    params
    })
)

/**
 * 会员等级列表
 * @type {AsyncThunk<Promise<*>, void, AsyncThunkConfig>}
 */
export const getMemberLevelListAction = createAsyncThunk(
    getTypePrefix(user.getMemberLevelList),
    async (params) => await okHttp(user.getMemberLevelList, {
        method: 'GET',
	    params
    })
)

/**
 * 注册店铺列表
 * @type {AsyncThunk<Promise<*>, void, AsyncThunkConfig>}
 */
export const getUserShopCodeListAction = createAsyncThunk(
    getTypePrefix(user.getUserShopCodeList),
    async (params) => await okHttp(user.getUserShopCodeList, {
        method: 'GET',
	    params
    })
)

/**
 * 导出备注
 * @type {AsyncThunk<Promise<*>, void, AsyncThunkConfig>}
 */
export const downloadEmployeeRemarkAction = createAsyncThunk(
    getTypePrefix(sys.downloadEmployeeRemarkUrl),
    async (params) => await okHttp(sys.downloadEmployeeRemarkUrl, {
        method: 'POST',
	    ...params
    })
)